import React from 'react'

function UhmDisclaimer() {
    return (
        <div>
            <sup>1 </sup>There is NO WARRANTY, ACTUAL OR IMPLIED, for the accuracy of this information.Statement is not a commitment to lend.Estimated savings are based on current interest rate payment savings over the life of the loan. Any actual savings can only be determined after qualification and at the time of refinancing.
        </div>
    )

}

export default UhmDisclaimer;
   